import { Typography } from '@mui/material';
import React from 'react';

const statusTag = (title: string, classValue: string): JSX.Element => {
  return <Typography className={`tag ${classValue}`}>{title}</Typography>;
};
export default statusTag;
